import { render, staticRenderFns } from "./PageProductStocks.vue?vue&type=template&id=b5ccbe66&"
import script from "./PageProductStocks.vue?vue&type=script&lang=js&"
export * from "./PageProductStocks.vue?vue&type=script&lang=js&"
import style0 from "./PageProductStocks.vue?vue&type=style&index=0&id=b5ccbe66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports